export default __webpack_public_path__ + "static/media/vasili.3df1634c.jpg";